import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "@components/card-title/card-title-component";
import * as d1 from "@components/spinner-button/spinner-button-component";
import * as d2 from "./components/calendar/calendar-component.ts";
import * as d3 from "./components/courses/courses-component.ts";
import * as d4 from "./components/carousel/carousel-component.ts";
import * as d5 from "./components/products/products-component.ts";
import * as d6 from "./components/user-integration/user-integration-component.ts";
import * as d7 from "./components/projects-created/projects-created-component.ts";
import * as d8 from "./components/next-steps/next-steps-component.ts";
export const name = "home-page";
export const template = "\n\n\n\n\n\n\n\n\n\n\n<section class=\"px-2 py-5 md:px-6 md:py-5\">\n\n\t<div class=\"flex flex-wrap md:flex-nowrap gap-4\">\n\t\t<div class=\"flex-1 md:order-1\">\n\t\t\t<next-steps-component steps-to-show.bind=\"stepsToShow\"></next-steps-component>\n\t\t</div>\n\t\t<div class=\"md:order-none\">\n\t\t\t<calendar-component></calendar-component>\n\t\t</div>\n\t</div>\n</section>";
export default template;
export const dependencies = [ d0, d1, d2, d3, d4, d5, d6, d7, d8 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
